import { ActionItemCtaLabelWithIcon } from "../common/ActionItemCtaLabelWithIcon";
import { ProductSelector } from "./ProductSelector";
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

export const ProductSelectorWrapper = ({ config, labelsStore, setSelector }) => (
  <ProductSelector
    config={config}
    renderFunction={(selector) => {
      setSelector(selector);
      return <ActionItemCtaLabelWithIcon labelName={labelsStore.editConfiguration} iconSize={pesIconSizes.SMALL} iconName={'product_selector'}/>;
    }}
  />
);